<template class="full-height">
  <div class="app-container" style="position: relative; height: 100%; padding: 15px">
    <!-- <el-dialog
      :top="dialogTopMargin"
      :title="fileTypeDesc == 'payment' ? '請款單' : '發票'"
      :visible.sync="dialogFileVisible"
      width="30%"
    >
      <el-card class="box-card">
        <div
          v-for="o in fileTypeDesc == 'payment' ? files1 : files2"
          :key="o.url"
          class="text item"
        >
          <a class="link" :href="o.url">{{ o.fileName }}</a>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFileVisible = false">取 消</el-button>
      </span>
    </el-dialog> -->

    <!-- <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth">
          <el-form-item
            :label="funcName + '名稱'"
            prop="viewPointName"
            :rules="[
              { required: true, message: '請輸入景點名稱', trigger: 'blur' },
            ]"
          >
            <el-input v-model="form.viewPointName"></el-input>
          </el-form-item>

          <el-form-item :label="funcName + '座標'">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="緯度(lat)"
                  prop="lat"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標緯度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標緯度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="form.lat"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="經度(lng)"
                  prop="lng"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標經度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標經度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="form.lng"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">確 定</el-button>
      </span>
    </el-dialog> -->

    <!-- 旅客使用紀錄 -->
    <el-dialog
      @closed="currentTravelID = null"
      append-to-body
      modal-append-to-body
      :top="dialogTopMargin"
      :title="`【${currentTravelName}】旅客使用紀錄`"
      :visible.sync="travelersDetailsDialogNoteVisible"
      width="55%"
    >
      <TravelersUsed :travelID="currentTravelID" :travelName="currentTravelName"></TravelersUsed>
      <span slot="footer" class="dialog-footer">
        <el-tooltip content="匯 出 Excel">
          <el-button
            style="cursor: pointer"
            type="primary"
            @click="exportExcel"
            :loading="exportExcelLoading"
            >匯出資料</el-button
          >
        </el-tooltip>
        <el-button @click="travelersDetailsDialogNoteVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog>

    <!-- 單據下載 -->
    <el-dialog
      :top="dialogTopMargin"
      :title="fileTypeDesc == 'payment' ? '請款單' : '發票'"
      :visible.sync="dialogFileVisible"
      width="30%"
    >
      <el-card class="box-card">
        <div
          v-for="o in fileTypeDesc == 'payment' ? files1 : files2"
          :key="o.url"
          class="text item"
        >
          <a class="link" :href="o.url">{{ o.fileName }}</a>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFileVisible = false" type="danger">關 閉</el-button>
      </span>
    </el-dialog>

    <!-- <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth">
          <el-form-item
            :label="funcName + '名稱'"
            prop="viewPointName"
            :rules="[
              { required: true, message: '請輸入景點名稱', trigger: 'blur' },
            ]"
          >
            <el-input v-model="form.viewPointName"></el-input>
          </el-form-item>

          <el-form-item :label="funcName + '座標'">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="緯度(lat)"
                  prop="lat"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標緯度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標緯度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="form.lat"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="經度(lng)"
                  prop="lng"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標經度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標經度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="form.lng"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">確 定</el-button>
      </span>
    </el-dialog> -->

    <!-- <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-row>
          <el-col :span="15">
            <el-form-item v-if="sumPrice">
              <el-alert :closable="false" type="success" effect="dark">
                <template slot="title">
                  <span style="font-size: 20px; font-weight: bolder">{{
                    `總金額：${sumPrice}`
                  }}</span>
                </template>
              </el-alert>
              <el-tag size="mini" v-if="dateRangeInfo"
                >計算區間：{{ dateRangeInfo }}</el-tag
              >
            </el-form-item>

            <el-form-item label="查詢年月">
              <el-select
                @change="getList"
                v-model="listQuery.dates"
                filterable
                placeholder="請選擇"
                value-key="id"
              >
                <el-option
                  v-for="item in dates"
                  :key="item.id"
                  :label="`${item.year}-${item.month}`"
                  :value="item"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="查詢">
              <el-input
                v-model="listQuery.qry"
                placeholder="輸入團號或團名稱"
              />
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="getList">查詢</el-button>
            </el-form-item>

           <el-form-item>
          <el-button type="success" @click="addData">新增</el-button>
        </el-form-item> 
            <el-form-item>
              <el-button
                style="cursor: pointer"
                v-loading="listLoading"
                type="success"
                icon="el-icon-refresh-left"
                circle
                @click="refresh()"
              ></el-button>
            </el-form-item>

            <el-form-item>
              <el-button
                size="medium"
                type="danger"
                icon="el-icon-download"
                @click="download('payment')"
                >請款單下載</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                size="medium"
                type="warning"
                icon="el-icon-download"
                @click="download('invoice')"
                >發票下載</el-button
              >
            </el-form-item>
          </el-col>

          <el-col :span="9">
            <el-form-item>
              <el-alert
                type="success"
                effect="dark"
                style="margin: 3px"
                :closable="false"
              >
                <template slot="title">
                  1，計算區間：例.2022-09-26-2022-10-25，以行程結束日於此區間內做為呈現。<br />2，當團旅客數未滿10人將以10人計算。
                </template>
              </el-alert>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div> -->

    <el-row :gutter="12">
      <el-col :span="24" :sm="24" :lg="8" :xl="11">
        <div style="display: flex; gap: 0 8px; align-items: flex-start; padding-bottom: 8px">
          <div style="display: flex; flex-direction: column; gap: 6px 0; flex-grow: 2">
            <el-tag v-if="dateRangeInfo">計算區間：{{ dateRangeInfo }}</el-tag>
            <el-tag type="success" v-if="headCountTitle">{{ headCountTitle }}</el-tag>
            <el-tag type="success" v-if="balanceTitle">{{ balanceTitle }}</el-tag>
          </div>
          <div style="display: flex; flex-direction: column; gap: 6px 0; flex-grow: 1">
            <el-tag type="danger" style="font-size: 16px; font-weight: bolder">
              <div style="display: flex; justify-content: space-between">
                <span> 總金額： </span>
                {{ sumPrice }}
              </div>
            </el-tag>
            <el-tag
              type="danger"
              style="font-size: 16px; font-weight: bolder"
              v-if="!!headCountTitle"
            >
              <div style="display: flex; justify-content: space-between">
                <span> 可用人數： </span>
                {{ headCount.toLocaleString() }}
              </div>
            </el-tag>
            <el-tag
              type="danger"
              style="font-size: 16px; font-weight: bolder"
              v-if="!!balanceTitle"
            >
              <div style="display: flex; justify-content: space-between">
                <span> 餘額折抵： </span>
                ${{ balance.toLocaleString() }}
              </div>
            </el-tag>
          </div>
        </div>
      </el-col>

      <el-col :span="24" :sm="24" :lg="16" :xl="13">
        <el-form :inline="true" class="filter-form">
          <!-- <el-form-item v-if="sumPrice">
        <el-alert :closable="false" type="success" effect="dark">
          <template slot="title">
            <span style="font-size: 20px; font-weight: bolder">{{
              `總金額：${sumPrice}`
            }}</span>
          </template>
        </el-alert>
        <el-tag size="mini" v-if="dateRangeInfo"
          >計算區間：{{ dateRangeInfo }}</el-tag
        >
      </el-form-item> -->

          <el-form-item label="查詢年月">
            <el-select
              @change="getList"
              v-model="listQuery.dates"
              filterable
              placeholder="請選擇"
              value-key="id"
            >
              <el-option
                v-for="item in dates"
                :key="item.id"
                :label="`${item.year}-${item.month < 10 ? '0' + item.month : '' + item.month}`"
                :value="item"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="查詢">
            <el-input
              v-model="listQuery.qry"
              placeholder="輸入團號或團名稱"
              @keyup.enter.native="getList"
            />
          </el-form-item>

          <el-button
            type="primary"
            @click="getList"
            icon="el-icon-search"
            circle
            style="margin-top: 8px; margin-left: 5px"
            :disabled="listLoading"
          ></el-button>
          <!-- <el-button
            type="warning"
            @click="addData"
            circle
            icon="el-icon-plus"
            :disabled="listLoading"
          ></el-button> -->
          <el-button
            style="cursor: pointer"
            type="success"
            :loading="listLoading"
            circle
            icon="el-icon-refresh-left"
            @click="refresh()"
          ></el-button>
          <el-button size="medium" icon="el-icon-download" @click="download('payment')"
            >請款單下載</el-button
          >
          <el-button
            size="medium"
            type="danger"
            icon="el-icon-download"
            @click="download('invoice')"
            >發票下載</el-button
          >
        </el-form>
      </el-col>
    </el-row>

    <el-alert
      style="background-color: #ffd643; color: #4b4b4b; margin-bottom: 10px"
      :closable="false"
      type="info"
      effect="dark"
    >
      <template slot="title">
        計算區間：ex.2022-09-26-2022-10-25，以行程結束日於此區間內做為呈現<br />
        <!-- 2、當團旅客數未滿10人將以10人計算<br /> -->
        <!-- 3、當團旅遊天數不足3天將以3天計算。 -->
      </template>
    </el-alert>

    <div style="position: relative; height: 70%">
      <el-table
        v-loading="listLoading"
        size="mini"
        ref="totalTable"
        :data="list"
        border
        fit
        show-summary
        :summary-method="getSummaries"
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="left"
          label="App+網卡總金額(含稅)"
          width="150"
          prop="totalPriceTaxStr"
        >
          <template slot-scope="scope">
            <span class="tax-price">{{ scope.row.pricing.totalPriceTaxStr }}</span>
          </template>
        </el-table-column>
        <!-- 
        <el-table-column align="left" label="App+網卡總金額(未稅)" width="150">
          <template slot-scope="scope">
            <span class="no-tax-price">{{
              scope.row.pricing.totalPriceStr
            }}</span>
          </template>
        </el-table-column> -->

        <el-table-column align="left" label="網卡項目" width="150">
          <template slot-scope="scope" v-if="scope.row.networkCardSouece">
            <span>{{ scope.row.networkCardSouece.cardName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡金額" width="80">
          <template slot-scope="scope" v-if="scope.row.networkCardSouece">
            <span style="font-size: 17px">${{ scope.row.networkCardSouece.price }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡數量" width="80">
          <template slot-scope="scope" v-if="scope.row.networkCardSouece">
            <span style="font-size: 17px">{{ scope.row.networkCardCount }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡運費" width="80">
          <template slot-scope="scope" v-if="scope.row.networkCardSouece">
            <span style="font-size: 17px">{{
              scope.row.pricing.networkCardPostFeePriceTaxStr
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="left"
          label="網卡使用總金額(含稅)"
          width="150"
          prop="networkCardUseTotalPriceTaxStr"
        >
          <template slot-scope="scope">
            <span class="tax-price">{{ scope.row.pricing.networkCardUseTotalPriceTaxStr }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="left"
          label="App使用總金額(含稅)"
          width="150"
          prop="appUseTotalPriceTaxStr"
        >
          <template slot-scope="scope">
            <span class="tax-price">{{ scope.row.pricing.appUseTotalPriceTaxStr }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="left" label="App使用總金額(未稅)" width="150">
          <template slot-scope="scope">
            <span class="no-tax-price">{{
              scope.row.pricing.appUseTotalPriceStr
            }}</span>
          </template>
        </el-table-column> -->

        <el-table-column align="left" label="團號" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.tourGroupNo }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="left" label="團名" width="180">
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
             <div>
              <el-tag>
                出發{{ `${row.beginDate} ${row.beginTime}` }} - 回程{{
                  `${row.endDate} ${row.endTime}`
                }}
              </el-tag>
            </div> 
          </template>
        </el-table-column>-->

        <el-table-column align="center" label="團名" width="350">
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
            <div>
              <el-tag style="font-size: 14px">
                出發
                <span style="color: red">{{ `${row.beginDate} ${row.beginTime}` }}</span>
                - 回程
                <span style="color: red">{{ `${row.endDate} ${row.endTime}` }}</span>
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="出團日" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.beginDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="結束日" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.endDate }}</span>
          </template>
        </el-table-column> -->

        <el-table-column align="center" label="天數" width="80" prop="totalday">
          <template slot-scope="scope">
            <span>{{ scope.row.totalday }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅客數" width="80" prop="tourist">
          <template slot-scope="scope">
            <span>{{ scope.row.tourist }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="使用旅客名單" width="160">
          <template slot-scope="scope">
            <el-button @click="getTravelersDetails(scope.row)" type="info" size="mini"
              >查看</el-button
            >
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="網卡使用數" width="300">
          <template slot-scope="scope">
            <el-row v-if="scope.row.networkCardCount > 0">
              <el-tag
                style="font-size: 13px"
                v-if="scope.row.networkCardSouece"
                size="medium"
                >{{
                  `【${scope.row.networkCardSouece.cardName}】 【$${scope.row.networkCardSouece.price}】/張`
                }}</el-tag
              >
              <br />
              <span style="font-size: 17px"
                >{{ scope.row.networkCardCount }}張</span
              >
            </el-row>
          </template>
        </el-table-column> -->

        <!-- <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)"
              >編輯</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import TravelersUsed from '../components/travelersUsedDetailsComponent.vue'
import request from '@/utils/request'

import { getAgencyTravelsAndOtherInformation, getCheckOutYearMonth } from '@/api/agency'

var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'AccountsPayableManagement',
  components: {
    Pagination,
    TravelersUsed,
  },
  data() {
    return {
      exportExcelLoading: false,
      currentTravelID: null,
      currentTravelName: null,
      travelersDetailsDialogNoteVisible: false,
      fileTypeDesc: null,
      dialogFileVisible: false,
      dateRangeInfo: null,
      sumPrice: 0,
      headCount: 0, // 可用人數
      headCountTitle: '', // 可用人數方案標題
      balance: 0, // 餘額折抵
      balanceTitle: '', // 餘額折抵方案標題
      funcName: '旅遊團',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        dates: null,
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        filterType: 3,
      },
      total: 0,
      list: [],
      dates: [],
      files1: [],
      files2: [],
      totalRow: {},
    }
  },
  async created() {
    this.form = defaultForm
    await this.getCheckOutYearMonth()
    await this.getList()
  },
  updated() {
    this.$nextTick(() => {
      this.$refs['totalTable'].doLayout()
    })
  },
  methods: {
    async refresh() {
      this.listQuery = {
        dates: null,
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        filterType: 3,
      }
      await this.getList()
    },
    exportExcel() {
      let vm = this
      vm.exportExcelLoading = true

      const url = `/Log/exportTravelerData?travelID=${vm.currentTravelID}`
      request({
        url: url,
        method: 'get',
        responseType: 'blob',
      })
        .then(response => {
          let filename
          if (response.headers) {
            const hasContentDisposition = 'content-disposition' in response.headers
            if (hasContentDisposition) {
              let contentDisposition = response.headers['content-disposition']
              debugger
              const disposition = decodeURIComponent(contentDisposition)
              filename = disposition.split(';')[1].split('=')[1].trim()
            }
          }

          filename = !filename
            ? `${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`
            : filename
          const a = document.createElement('a')
          const u = window.URL.createObjectURL(response)
          a.href = u
          a.download = filename
          a.click()
          vm.$notify({
            title: '成功',
            message: '操作紀錄Excel處理完成',
            type: 'success',
          })
        })
        .catch(error => {
          console.log('error', error)
          alert(`${error.status}: ${error.statusText || 'error'}`)
        })
        .finally(() => {
          vm.exportExcelLoading = false
        })
    },
    getTravelersModifyStatusStyle(status) {
      let r = ''
      switch (status) {
        case 1:
        case 2:
          r = 'success'
          break
        case 3:
        case 4:
          r = ''
          break
        case 5:
          r = 'danger'
          break
        default:
          break
      }
      return r
    },

    async getTravelersDetails(row) {
      this.currentTravelID = row.id
      this.currentTravelName = row.travelName
      this.travelersDetailsDialogNoteVisible = true
    },
    async download(parm) {
      await this.getList()

      if (parm == 'payment' && this.files1.length == 0) {
        alert('請款單尚未產生')
        return
      } else if (parm == 'invoice' && this.files2.length == 0) {
        alert('發票尚未產生')
        return
      }
      this.fileTypeDesc = parm
      this.dialogFileVisible = true
    },
    async getCheckOutYearMonth() {
      let resp = await getCheckOutYearMonth()
      this.dates = resp.data
      if (this.dates.length > 1) {
        this.listQuery.dates = this.dates[1]
      }
    },
    getSummaries(params) {
      if (!params) return
      const { columns, data } = params
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '總計'
          return
        }
        switch (column.property) {
          case 'totalPriceTaxStr':
            sums[index] = this.totalRow.totalPriceTaxSumStr || 0
            break
          case 'networkCardUseTotalPriceTaxStr':
            sums[index] = this.totalRow.networkCardUseTotalPriceTaxSumStr || 0
            break
          case 'appUseTotalPriceTaxStr':
            sums[index] = this.totalRow.appUseTotalPriceTaxSumStr || 0
            break
          case 'totalday':
            sums[index] = this.totalRow.totaldaySumStr || 0
            break
          case 'tourist':
            sums[index] = this.totalRow.touristSumStr || 0
            break
          default:
            sums[index] = ''
            break
        }
      })
      console.log(sums)
      return sums
    },
    // addData() {
    //   this.dialogVisible = true;
    // },
    // editData(row) {
    //   this.form = row;
    //   this.dialogVisible = true;
    // },
    // async saveData() {
    //   let vm = this;
    //   if (!confirm(`確定要儲存【${vm.funcName}}】資料?`)) {
    //     return;
    //   }

    //   this.$refs["form"].validate(async (valid) => {
    //     if (valid) {
    //       vm.dialogLoading = true;
    //       let resp = await saveViewPoint(this.form);
    //       await vm.getList();
    //       this.dialogVisible = false;
    //       vm.dialogLoading = false;
    //       Message({
    //         message: "資料處理完成",
    //         type: "success",
    //         duration: 5 * 1000,
    //       });
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    async getList() {
      let vm = this
      vm.listLoading = true
      let resp = await getAgencyTravelsAndOtherInformation(vm.listQuery)
      if (resp.data.fileInfo) {
        let fileInfo = JSON.parse(resp.data.fileInfo)

        const file1 = fileInfo.filter(v => {
          return v.fileType == 21
        })

        if (file1.length > 0) {
          vm.files1 = file1[0].urls
        } else {
          vm.files1 = []
        }

        const file2 = fileInfo.filter(v => {
          return v.fileType == 22
        })

        if (file2.length > 0) {
          vm.files2 = file2[0].urls
        } else {
          vm.files2 = []
        }
      } else {
        vm.files1 = []
        vm.files2 = []
      }

      vm.dateRangeInfo = resp.data.dateRangeInfo
      vm.sumPrice = resp.data.sumPriceStr == undefined ? 0 : resp.data.sumPriceStr
      // ----------------------------------------------------------------
      vm.headCount = resp.data.headCount
      vm.headCountTitle = resp.data.headCountTitle
      vm.balance = resp.data.balance
      vm.balanceTitle = resp.data.balanceTitle
      // ----------------------------------------------------------------
      vm.list = resp.data.data
      vm.total = resp.data.total
      vm.totalRow = {
        totalPriceTaxSumStr: resp.data.totalPriceTaxSumStr,
        networkCardUseTotalPriceTaxSumStr: resp.data.networkCardUseTotalPriceTaxSumStr,
        appUseTotalPriceTaxSumStr: resp.data.appUseTotalPriceTaxSumStr,
        totaldaySumStr: resp.data.totaldaySumStr,
        touristSumStr: resp.data.touristSumStr,
      }
      vm.listLoading = false
    },
  },
}
</script>

<style scoped>
/deep/.el-table .el-table__footer-wrapper .cell {
  font-size: 17px;
  color: green;
  font-weight: bold;
  text-align: right;
}

/deep/.el-table .el-table__footer-wrapper .el-table_1_column_1 .cell {
  color: #696266;
  text-align: center;
}

/deep/.el-table .el-table__footer-wrapper .el-table_1_column_11 .cell {
  color: #696266;
  text-align: center;
}

/deep/.el-table .el-table__footer-wrapper .el-table_1_column_12 .cell {
  color: #696266;
  text-align: center;
}
</style>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding: 15px !important;
}

.no-tax-price {
  font-size: 17px;
  color: blue;
  font-weight: bold;
}

.tax-price {
  font-size: 17px;
  color: green;
  font-weight: bold;
  display: inline-block;
  width: 100%;
  text-align: right;
}

.link {
  font-size: 20px;
  color: skyblue;
  margin: 5px;
  cursor: pointer;
}

.link :hover {
  color: blue;
}
</style>
